var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layout',[_c('v-container',{staticClass:"justify-center align-center fill-height",attrs:{"fluid":""}},[_c('LogoLoadsureTagline',{attrs:{"dark":"","maxWidth":500}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }